import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { createHook } from './hook';

function hasAdditionalProps(props) {
  for (var i in props) {
    return true;
  }

  return false;
}

export function createSubscriber(Store) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      selector = _ref2.selector,
      _ref2$displayName = _ref2.displayName,
      displayName = _ref2$displayName === void 0 ? '' : _ref2$displayName;

  var useStore = createHook(Store, {
    selector: selector
  });

  var Subscriber = function Subscriber(_ref) {
    var children = _ref.children,
        rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

    var api = useStore(hasAdditionalProps(rest) ? rest : undefined);
    return children.apply(void 0, _toConsumableArray(api));
  };

  Subscriber.displayName = displayName || "Subscriber(".concat(Store.key[0], ")");
  return Subscriber;
}